import axios from "axios";
import { authHeader, isTokenExpired } from "../helpers";
import { Buffer } from "buffer";

export const myDesignService = {
  fetchMyDesigns,
  updateFolderId,
  fetchSingleMyDesign,
  fetchZones,
  fetchStats,
  fetchGlobalStats,
  requestCampaign,
  updateTimezone,
  sendNotification,
  updateRedirect,
  uploadVideo,
  uploadListFiles,
  uploadModel,
  fetchSelectedZoneContent,
  updatePlaylistActivation,
  fetchPlaylist,
  savePlaylistPosition,
  updatePlaylistItemInfos,
  addOrRemoveElementInPlaylist,
  createMyDesign,
  associateImageMyDesign,
  associateBorderlessImageMyDesign,
  createTargets,
  deleteTarget,
  createZones,
  deleteZone,
  checkTargetExist,
  duplicateTargets,
  updateTarget,
  fetchCampaigns,
  fetchScheduledCampaigns,
  fetchCampaignPlaylist,
  fetchCampaignContent,
  addElementToCampaignPlaylist,
  deleteElementToCampaignPlaylist,
  updateCampaignPlaylist,
  fetchAvailableCampaigns,
  campaignUniqueKeyExists,
  createCampaign,
  updateCampaign,
  getCampaignInfo,
  getAuthorizedAccounts,
  getDetailsAuthorizations,
  addAccountAuthorization,
  deleteAccountAuthorization,
  removeAccessToZone,
  addAccessToZone,
  updateOptionAccess,
  addMultipleAccessZone,
  removeMultipleAccessZone,
  updateImageZone,
  updateZoneLabel,
  updateCampaignVisible,
  updateCampaignPublish,
  updateExparienceFromMyDesign,
  getArConfiguration,
  getExparienceArConfiguration,
  updateMolding,
  updateSize,
  fetchPlayerContent,
  updateMyDesignPlayerMode,
  generateImageDescriptors,
  getIpFromDevice,
  updateConfidential,
};

function fetchMyDesigns(offset = "default", limit = "default") {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  if (offset === "default" && limit === "default") {
    return fetch(`${process.env.REACT_APP_API_URL}/frames/me`, requestOptions)
      .then((res) => isTokenExpired(res))
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        } else {
          const error = (res && res.message) || res.statusText;
          return Promise.reject(error);
        }
      });
  } else {
    return fetch(
      `${process.env.REACT_APP_API_URL}/frames/me?offset=${offset}&limit=${limit}`,
      requestOptions
    )
      .then((res) => isTokenExpired(res))
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        } else {
          const error = (res && res.message) || res.statusText;
          return Promise.reject(error);
        }
      });
  }
}

function fetchSingleMyDesign(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/frames/me/${id}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchZones(frameId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/frames/${frameId}/zones`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchStats(frameId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/frames/${frameId}/statistics`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchGlobalStats(start, end) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/frames/zones?from=${start}&to=${end}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function requestCampaign(campaignForm, targetId) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: campaignForm.cellphoneNumber
      ? JSON.stringify({
          mailContent: campaignForm.mailContent,
          cellphoneNumber: campaignForm.cellphoneNumber,
          targetId,
        })
      : JSON.stringify({
          mailContent: campaignForm.mailContent,
          targetId,
        }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/campaigns/request`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.text();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateFolderId(externalId, label, frameId) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({
      label,
      externalId,
    }),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/frames/${frameId}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return Promise.resolve(res);
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateTimezone(frameId, targetId, timeZone, updatedTargets) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({
      timeZone: timeZone.label,
    }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/frames/${frameId}/target/${targetId}/update-tz`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return updatedTargets;
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function sendNotification(frameId, frameName, label, zoneName) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify({
      frameName: frameName,
    }),
  };

  let url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/notification/" +
    label;

  if (zoneName != null) url += "/" + zoneName;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 201) {
        return Promise.resolve("ok");
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateRedirect(infos, newUrl, title, description, message) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({
      color: infos.color,
      label: infos.label,
      targetUrl: newUrl,
      title,
      description,
      message,
    }),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    infos.frameId +
    "/zones/" +
    infos.target +
    "/" +
    infos.index;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 201) {
        return Promise.resolve({ newUrl, infos });
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function uploadModel(id, data) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  const url = process.env.REACT_APP_API_URL + "/zones/" + id + "/model";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function uploadVideo(infos, fileInfo, handleProgress) {
  const formData = new FormData();
  formData.append("videoFile", fileInfo.file, fileInfo.file.name);
  formData.append("title", fileInfo.title);
  formData.append("description", fileInfo.description);
  formData.append("message", fileInfo.message);

  const requestOptions = {
    headers: authHeader(true),
    onUploadProgress: (progressEvent) => {
      var percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      //I used an observable to pass the data to a component and subscribed to it, to fill the progressbar
      handleProgress(percentCompleted);
    },
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    infos.frameId +
    "/zones/" +
    infos.target +
    "/" +
    infos.index +
    "/video";

  return axios
    .put(url, formData, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function uploadListFiles(infos, fileInfo, handleProgress, index) {
  const formData = new FormData();
  for (const file of fileInfo.file) {
    formData.append("files", file, file.name);
  }
  formData.append("title", fileInfo.title);
  formData.append("description", fileInfo.description);

  const requestOptions = {
    headers: authHeader(true),
    body: formData,
    onUploadProgress: (progressEvent) => {
      var percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      //I used an observable to pass the data to a component and subscribed to it, to fill the progressbar
      handleProgress(percentCompleted, index);
    },
  };

  const url = process.env.REACT_APP_API_URL + "/zones/" + infos.id + "/upload";

  return axios
    .put(url, formData, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchSelectedZoneContent(zoneId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/zones/${zoneId}/content`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function addOrRemoveElementInPlaylist(zoneId, elementId, activated) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({
      playlist: activated,
    }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/zones/${zoneId}/content/${elementId}/playlist`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.text(); //API send text 'OK'
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateExparienceFromMyDesign(frameId, targetId, molding, size) {
  const requestOptions =
    molding && size
      ? {
          method: "POST",
          headers: authHeader(),
          body: JSON.stringify({
            molding,
            size,
          }),
        }
      : {
          method: "POST",
          headers: authHeader(),
        };

  return fetch(
    `${process.env.REACT_APP_API_URL}/frames/${frameId}/targets/${targetId}/exparience`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json(); // API Send OK
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updatePlaylistActivation(zoneId, value) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({
      id: zoneId,
      playlist: value,
    }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/zones/${zoneId}/playlist`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.text(); //API send text 'OK'
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchPlaylist(zoneId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/zones/${zoneId}/playlist`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updatePlaylistItemInfos(zoneId, elementId, infos) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({
      title: infos.title,
      description: infos.description,
    }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/zones/${zoneId}/content/${elementId}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.text();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function savePlaylistPosition(zoneId, elementId, newPosition) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({
      position: newPosition,
    }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/zones/${zoneId}/content/${elementId}/position`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.text();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function createMyDesign(folderId, designName, confidentiality) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify({
      externalId: folderId,
      label: designName,
      confidentiality,
    }),
  };

  return fetch(process.env.REACT_APP_API_URL + "/frames", requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function associateImageMyDesign(fileInfo, frameId) {
  const formData = new FormData();
  formData.append(
    "imageFile",
    fileInfo[0],
    fileInfo[0].name.replaceAll(/\s/g, "")
  );

  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: formData,
  };

  const url = process.env.REACT_APP_API_URL + "/frames/" + frameId + "/image";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 201) {
        return Promise.resolve("ok");
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function associateBorderlessImageMyDesign(fileInfo, frameId) {
  const formData = new FormData();

  formData.append(
    "imageFile",
    fileInfo[0],
    fileInfo[0].name.replaceAll(/\s/g, "")
  );

  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: formData,
  };

  const url =
    process.env.REACT_APP_API_URL + "/frames/" + frameId + "/image-borderless";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function createTargets(frameId, targets) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(targets),
  };

  const url = process.env.REACT_APP_API_URL + "/frames/" + frameId + "/targets";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 201) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function deleteTarget(frameId, target) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
    body: JSON.stringify({
      label: target.label,
    }),
  };

  const url = process.env.REACT_APP_API_URL + "/frames/" + frameId + "/targets";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 201) {
        return Promise.resolve("ok");
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function duplicateTargets(frameId, target, targetId) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(target),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/targets/" +
    targetId +
    "/duplicate";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function updateTarget(targetId, target, targetLabel) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify(target),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    targetId +
    "/targets/" +
    targetLabel;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve("ok");
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function createZones(frameId, zones, target, files) {
  const formData = new FormData();
  formData.append("zones", JSON.stringify(zones));
  for (const file of files) {
    formData.append("files", file[0], file[0].name.replaceAll(/\s/g, ""));
  }
  const requestOptions = {
    method: "POST",
    headers: authHeader(true),
    body: formData,
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/targets/" +
    target +
    "/zones";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 201) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function updateImageZone(frameId, target, zoneIndex, file) {
  const formData = new FormData();
  formData.append("imageFile", file[0], file[0].name.replaceAll(/\s/g, ""));
  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: formData,
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/zones/" +
    target +
    "/" +
    zoneIndex +
    "/image";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 201) {
        return res.text();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function deleteZone(frameId, zone, target) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
    body: JSON.stringify({
      target,
      index: zone,
    }),
  };

  const url = process.env.REACT_APP_API_URL + "/frames/" + frameId + "/zones";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 201) {
        return Promise.resolve("ok");
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function checkTargetExist(frameId, targetName) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/targets/" +
    targetName +
    "/exists";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function fetchCampaigns(frameId, targetId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/targets/" +
    targetId +
    "/campaigns";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function fetchScheduledCampaigns(frameId, targetId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/targets/" +
    targetId +
    "/campaigns/scheduled";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function fetchCampaignsScheduled(frameId, targetId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/targets/" +
    targetId +
    "/campaigns/scheduled";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function fetchCampaignPlaylist(campaignId, campaignZoneId, toastError) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/campaigns/" +
    campaignId +
    "/zones/" +
    campaignZoneId +
    "/playlist";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        toastError();
        return Promise.reject(error);
      }
    });
}

export function fetchCampaignContent(campaignId, toastError) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/campaigns/" +
    campaignId +
    "/userCampaigns";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        toastError();
        return Promise.reject(error);
      }
    });
}

export function addElementToCampaignPlaylist(
  campaignId,
  campaignZoneId,
  campaignUserId,
  toastError
) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify({
      campaignZoneId,
      campaignUserId,
    }),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/campaigns/" +
    campaignId +
    "/zones/" +
    campaignZoneId +
    "/playlist";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        toastError();
        return Promise.reject(error);
      }
    });
}

export function deleteElementToCampaignPlaylist(
  campaignId,
  campaignZoneId,
  campaignZonePlaylistId,
  toastError
) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/campaigns/" +
    campaignId +
    "/zones/" +
    campaignZoneId +
    "/playlist/" +
    campaignZonePlaylistId;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        toastError();
        return Promise.reject(error);
      }
    });
}

export function updateCampaignPlaylist(
  campaignId,
  campaignZoneId,
  campaignZonePlaylistId,
  position,
  toastError
) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({
      campaignZoneId,
      campaignZonePlaylistId,
      position,
    }),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/campaigns/" +
    campaignId +
    "/zones/" +
    campaignZoneId +
    "/playlist";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        toastError();
        return Promise.reject(error);
      }
    });
}

export function fetchAvailableCampaigns(frameId, toastError) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url =
    process.env.REACT_APP_API_URL + "/frames/" + frameId + "/campaigns";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        toastError();
        return Promise.reject(error);
      }
    });
}

export function campaignUniqueKeyExists(uniqueKey) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url =
    process.env.REACT_APP_API_URL + "/campaign/exists?uniqueKey=" + uniqueKey;
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function createCampaign(campaign, target, files) {
  const form = new FormData();
  form.append("campaign", JSON.stringify(campaign));
  form.append("target", JSON.stringify(target));
  form.append(
    "imageHeader",
    files.imageHeader[0],
    files.imageHeader[0].name.replaceAll(/\s/g, "")
  );
  form.append(
    "imageForm",
    files.imageForm[0],
    files.imageForm[0].name.replaceAll(/\s/g, "")
  );
  if (files.hasOwnProperty("logo") && files.logo.length > 0) {
    form.append(
      "logo",
      files.logo[0],
      files.logo[0].name.replaceAll(/\s/g, "")
    );
  }

  const requestOptions = {
    method: "POST",
    headers: authHeader(true),
    body: form,
  };
  const url = process.env.REACT_APP_API_URL + "/campaign";
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((response) => {
      if (response.status < 300) {
        return Promise.resolve("ok");
      } else {
        throw new Error("Unable to create campaign");
      }
    });
}

export function updateCampaign(campaign, target, files, campaignId) {
  const form = new FormData();
  form.append("campaign", JSON.stringify(campaign));
  form.append("target", JSON.stringify(target));
  if (files.hasOwnProperty("imageHeader") && files.imageHeader.length > 0) {
    form.append(
      "imageHeader",
      files.imageHeader[0],
      files.imageHeader[0].name.replaceAll(/\s/g, "")
    );
  }
  if (files.hasOwnProperty("imageForm") && files.imageForm.length > 0) {
    form.append(
      "imageForm",
      files.imageForm[0],
      files.imageForm[0].name.replaceAll(/\s/g, "")
    );
  }
  if (files.hasOwnProperty("logo") && files.logo.length > 0) {
    form.append(
      "logo",
      files.logo[0],
      files.logo[0].name.replaceAll(/\s/g, "")
    );
  }

  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: form,
  };
  const url = process.env.REACT_APP_API_URL + "/campaign/" + campaignId;
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((response) => {
      if (response.status < 300) {
        return Promise.resolve("ok");
      } else {
        throw new Error("Unable to update campaign");
      }
    });
}

export function getCampaignInfo(campaignId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = process.env.REACT_APP_API_URL + "/campaign/" + campaignId;
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function getAuthorizedAccounts(frameId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url =
    process.env.REACT_APP_API_URL + "/frames/" + frameId + "/accounts";
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function getDetailsAuthorizations(frameId, accountId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/frame-access-zones?accountId=" +
    accountId;
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function addAccountAuthorization(frameId, accountId, toastError) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/accounts/" +
    accountId;
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        toastError();
        return Promise.reject(error);
      }
    });
}

export function deleteAccountAuthorization(frameId, accountId, toastError) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/accounts/" +
    accountId;
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        toastError();
        return Promise.reject(error);
      }
    });
}

export function removeAccessToZone(frameId, accountId, zoneId, toastError) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
    body: JSON.stringify({
      accountId,
    }),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/frame-access-zone/" +
    zoneId;
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        toastError();
        return Promise.reject(error);
      }
    });
}

export function addAccessToZone(frameId, accountId, zoneId, toastError) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify({
      accountId,
      zones: [zoneId],
    }),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/frame-access-zones";
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        toastError();
        return Promise.reject(error);
      }
    });
}

export function addMultipleAccessZone(frameId, accountId, zonesId, toastError) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify({
      accountId,
      zones: zonesId,
    }),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/frame-access-zones";
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        toastError();
        return Promise.reject(error);
      }
    });
}

export function removeMultipleAccessZone(
  frameId,
  accountId,
  zonesId,
  toastError
) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
    body: JSON.stringify({
      accountId,
      zones: zonesId,
    }),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/frame-access-zones";
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        toastError();
        return Promise.reject(error);
      }
    });
}

export function updateOptionAccess(
  frameId,
  accountId,
  key,
  value,
  zoneId,
  toastError
) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({
      accountId,
      [key]: value,
    }),
  };

  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/frame-access-zone/" +
    zoneId;
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        toastError();
        return Promise.reject(error);
      }
    });
}

export function updateZoneLabel(targetUrl, frameId, target, zoneId, label) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({
      label,
      targetUrl,
    }),
  };
  const url =
    process.env.REACT_APP_API_URL +
    "/frames/" +
    frameId +
    "/zones/" +
    target +
    "/" +
    zoneId;
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve("ok");
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateCampaignPublish(id, value) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };

  const url = value
    ? `${process.env.REACT_APP_GATEWAY_URL}/admin/campaigns/${id}/publish`
    : `${process.env.REACT_APP_GATEWAY_URL}/admin/campaigns/${id}/unpublish`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res;
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateCampaignVisible(id, value) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };

  const url = value
    ? `${process.env.REACT_APP_GATEWAY_URL}/admin/campaigns/${id}/visible`
    : `${process.env.REACT_APP_GATEWAY_URL}/admin/campaigns/${id}/invisible`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res;
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getArConfiguration(id, myIp) {
  const requestOptions = {
    method: "GET",
    // headers: authHeader(),
  };

  const tmpIp = myIp ? Buffer.from(myIp).toString("base64") : "";
  const route = myIp
    ? `${process.env.REACT_APP_API_URL}/targets/${id}?ip=${tmpIp}`
    : `${process.env.REACT_APP_API_URL}/targets/${id}`;

  return fetch(route, requestOptions).then((res) => {
    if (res.status < 300) {
      return res.json();
    } else {
      const error = (res && res.message) || res.statusText;
      return Promise.reject(error);
    }
  });
}

function getExparienceArConfiguration(id, myIp, retrievalId) {
  const requestOptions = {
    method: "GET",
    // headers: authHeader(),
  };
  const tmpIp = myIp ? Buffer.from(myIp).toString("base64") : "";
  const route = myIp
    ? `${process.env.REACT_APP_GATEWAY_URL}/public/dm/${id}/webview?withCustom=true&ip=${tmpIp}&retrievalId=${retrievalId}`
    : `${process.env.REACT_APP_GATEWAY_URL}/public/dm/${id}/webview?withCustom=true&retrievalId=${retrievalId}`;

  return fetch(route, requestOptions).then((res) => {
    if (res.status < 300) {
      return res.json();
    } else {
      const error = (res && res.message) || res.statusText;
      return Promise.reject(error);
    }
  });
}

function updateMolding(id, molding) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({
      molding,
    }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/targets/${id}/molding`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateSize(id, size) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({
      size,
    }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/targets/${id}/size`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchPlayerContent(iv, content) {
  const requestOptions = {
    method: "GET",
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/play?iv=${iv}&content=${content}`,
    requestOptions
  ).then((res) => {
    if (res.status === 200) {
      return res.json();
    } else {
      return res.text().then((msg) => {
        if (msg) return Promise.reject(msg);
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      });
    }
  });
}

function updateMyDesignPlayerMode(zoneId, value) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({
      player: value,
    }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/zones/${zoneId}/player`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.text(); //API send text 'OK'
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function generateImageDescriptors(targetId) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/targets/${targetId}/descriptors`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.text(); //API send text 'OK'
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getIpFromDevice() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `https://ipinfo.io/json?token=${process.env.REACT_APP_GET_IP_TOKEN}`,
    requestOptions
  )
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        return Promise.reject("error");
      }
    })
    .catch((err) => {
      return Promise.reject("error");
    });
}

function updateConfidential(id, confidentiality) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
  };

  const route = confidentiality
    ? `${process.env.REACT_APP_API_URL}/frames/${id}/confidential`
    : `${process.env.REACT_APP_API_URL}/frames/${id}/unconfidential`;

  return fetch(route, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.text(); //API send text 'OK'
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}
